import { TerraDrawAdapterStyling } from "../common";

export const getDefaultStyling = (): TerraDrawAdapterStyling => {
	return {
		polygonFillColor: "#3f97e0",
		polygonOutlineColor: "#3f97e0",
		polygonOutlineWidth: 4,
		polygonOutlineOpacity: 1,
		polygonFillOpacity: 0.3,
		pointColor: "#3f97e0",
		pointOpacity: 1,
		pointOutlineColor: "#ffffff",
		pointOutlineOpacity: 1,
		pointOutlineWidth: 0,
		pointWidth: 6,
		lineStringColor: "#3f97e0",
		lineStringWidth: 4,
		lineStringOpacity: 1,
		zIndex: 0,
		markerUrl: undefined,
		markerHeight: undefined,
		markerWidth: undefined,
		markerAnchor: "bottom",
		lineStringDash: undefined,
	};
};
